import React from "react";
import TableUi from "../../../../../components/Layout/TableUI";
import useFetch from "../../../../../hooks/useFetch";
import { prettyDateFormat } from "../../../../../helpers/Utils";
import { IconDelete } from "../../../../../components/Layout/Icons";
import { removeOrderActionHistories } from "../../../../../redux/Actions/order_action_histories_action";
import { Tooltip } from "antd";
import InitialData from "../../../../../components/globals/InitialData";

const ActionHistoryContent = ({ order_id }) => {
  const { value, error, loading, setValue } = useFetch(
    "/api/v1/order_action_histories/" + order_id
  );

  if (error || loading || !value?.length)
    return <InitialData error={error} loading={loading} />;

  return (
    <div>
      <TableUi
        className="mb-0"
        hoverable={false}
        ths={["Type", "Date", "User", "Message", ""]}
      >
        {value.map((e) => {
          return (
            <TableUi.tr key={e.id}>
              <TableUi.td className={"p-left"}>{e.action_type}</TableUi.td>
              <TableUi.td>{prettyDateFormat(e.created_at)}</TableUi.td>
              <TableUi.td>{e.full_name}</TableUi.td>
              <TableUi.td>
                <div
                  style={{
                    wordWrap: "break-word",
                  }}
                >
                  {e.description}
                </div>
              </TableUi.td>
              <TableUi.td>
                <Tooltip placement="left" title="Remove">
                  <IconDelete
                    className="cursor-pointer"
                    onClick={() =>
                      removeOrderActionHistories(e.id).then((res) => {
                        if (res.success) {
                          setValue((prev) => prev.filter((x) => x.id !== e.id));
                        }
                      })
                    }
                  />
                </Tooltip>
              </TableUi.td>
            </TableUi.tr>
          );
        })}
      </TableUi>
    </div>
  );
};

export default ActionHistoryContent;
